<template>
  <div class="container-box">
    <div class="">
      <h2 class="title-type-1">
        캠페인 상품(지면) 추가
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          상품 지면 추가 후 상세 설정 옵션의 필수 정보 등록 및 노출 설정을 ON
          하셔야 광고가 출력됩니다.
        </span>
      </h2>

      <div
        class="accodion-type-1 mb-8"
        v-for="(media, i) in customBoardLists"
        :key="i"
        :class="`accodion-wrap-${i}`"
      >
        <div class="accodion-head">
          <v-checkbox
            color="#fecd00"
            off-icon="mdi-checkbox-blank"
            class="checkbox-type-1"
            hide-details
            v-model="allChx[i]"
            @change="accodionChxAll($event, i)"
          ></v-checkbox>

          <span class="thumb">
            <img
              :src="media.logo"
              style="width: 40px; height: 40px; border-radius: 4px"
            />
          </span>
          <span class="tit">
            {{ media.name }}
          </span>
          <a
            href="javascript:void(0);"
            class="arrow"
            :class="{
              active:
                accodionState[i] && accodionState[i].state
                  ? accodionState[i].state
                  : false,
            }"
            @click.prevent="toggleAccodion(i)"
          >
            <v-icon>mdi-chevron-up</v-icon>
          </a>
        </div>
        <v-expand-transition>
          <div
            class="accodion-body"
            v-if="
              accodionState[i] && accodionState[i].state
                ? accodionState[i].state
                : false
            "
          >
            <v-data-table
              :headers="accodionTblHeaders"
              :items="media.inventories"
              :items-per-page="-1"
              class="board-list-1"
              hide-default-footer
            >
              <template v-slot:body="{ items, headers }">
                <tbody>
                  <tr v-for="(item, j) in items" :key="j">
                    <td>
                      <v-checkbox
                        v-model="item.choice"
                        color="#fecd00"
                        off-icon="mdi-checkbox-blank"
                        class="checkbox-type-1"
                        @change="accodionChx(i, j)"
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td>
                      {{ item.name }}
                    </td>
                    <td>
                      <a href="javascript:void(0);" @click="preview(item)"
                        >미리보기</a
                      >
                    </td>
                    <td>
                      <div class="datepicker-type-1">
                        <v-icon>mdi-calendar-blank</v-icon>
                        <date-range-picker
                          v-model="item.dateRange"
                          :date-format="dateFormat"
                          :locale-data="localeData"
                          :ranges="false"
                          :time-picker="true"
                          :time-picker-seconds="true"
                          :time-picker-increment="1"
                          opens="right"
                          @update="updateDateRange(i, j, item.dateRange, item)"
                        ></date-range-picker>
                      </div>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        style="color: transparent"
                        @click="viewSchedule(item, media.id)"
                      >
                        <v-icon color="#fecd00"
                          >mdi-calendar-text-outline</v-icon
                        >
                      </a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        style="color: transparent"
                        @click="viewNote(item)"
                      >
                        <v-icon color="#fecd00">mdi-note-outline</v-icon>
                      </a>
                    </td>
                    <td>
                      {{ item.overlap_cnt }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-expand-transition>
      </div>

      <!--btn-group-->
      <div class="d-flex justify-end mt-10">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fff"
          class="button-type-1"
          @click.stop="cancel"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1 ml-4"
          @click.prevent="saveCampaignInventories"
        >
          저장
        </v-btn>
      </div>
      <!--//btn-group-->

      <SystemAlert v-model="showSystemAlert">
        <div slot="noti-text">{{ logResult }}</div>
        <div slot="noti-btns">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1"
            @click.stop="closePopup"
          >
            확인
          </v-btn>
        </div>
      </SystemAlert>
      <PreviewModal
        v-model="showPreview"
        :propsItem="previewItem"
      ></PreviewModal>
      <NoteModal v-model="showNote" :propsItem="previewItem"></NoteModal>
      <div v-if="showSchedule">
        <ScheduleModal
          v-model="showSchedule"
          :propsItem="previewItem"
          :propsMediaId="mediaId"
        ></ScheduleModal>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import DateRangePicker from 'vue2-daterange-picker';
import { toISOFormattedDate } from '@/utils/validation';
import { addCampaignInventory, getListCampaignInventory } from '@/api/campaign';
import SystemAlert from '~@/modal/SystemAlert.vue';
import PreviewModal from '@/components/modal/PreviewModal.vue';
import ScheduleModal from '@/components/modal/ScheduleModal.vue';

import NoteModal from '@/components/modal/NoteModal.vue';

export default {
  components: {
    DateRangePicker,
    SystemAlert,
    PreviewModal,
    NoteModal,
    ScheduleModal,
  },
  data: () => ({
    showSystemAlert: false,
    logResult: '',
    showPreview: false,
    previewItem: {},
    showNote: false,
    showSchedule: false,
    campaignInfo: {},
    mediaId: '',

    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    allChx: [],

    accodionState: [],

    mediasList: [
      {
        accodionPannel: true,
        inventories: [
          { choice: false, dateRange: { startDate: null, endDate: null } },
        ],
      },
    ],

    accodionChecked: [],

    accodionTblHeaders: [
      { text: '선택', value: 'choice', width: '6%', sortable: false },
      { text: '지면명', value: 'name', width: '14%', sortable: false },
      {
        text: '노출 지면 샘플',
        value: 'sample',
        width: '12%',
        sortable: false,
      },
      { text: '노출기간', value: '', width: '36%', sortable: false },

      { text: '스케줄', value: 'schedule', sortable: false },
      { text: '지면 메모', value: 'note', sortable: false },
      {
        text: '동시 노출 수',
        value: 'overlap_cnt',
        width: '10%',
        sortable: false,
      },
    ],
  }),
  computed: {
    customBoardLists() {
      const listWithInventory = this.mediasList.filter(item => {
        const hasInventory =
          Array.isArray(item.inventories) &&
          item.inventories.length &&
          item.inventories[0].id;
        return hasInventory;
      });
      return listWithInventory;
    },
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.campaignInfo.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.campaignInfo.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },
    accodionChxAll(e, i) {
      this.allChx[i] = e;
      const media = this.customBoardLists[i];
      media.inventories.map(inventory => {
        return (inventory.choice = this.allChx[i]);
      });
    },
    accodionChx(i, j) {
      const media = this.customBoardLists[i];
      const leng = media.inventories.length;
      let num = 0;
      media.inventories.map(v => {
        v.choice ? num++ : num;
      });

      num === leng ? (this.allChx[i] = true) : (this.allChx[i] = false);
    },

    toggleAccodion(i) {
      this.accodionState[i].state = !this.accodionState[i].state;
    },

    async listCampaignInventories() {
      const campaignId = this.$route.params.id;
      try {
        const { data } = await getListCampaignInventory(campaignId);

        let campaignInfo = data.campaign;
        this.campaignInfo = data.campaign;

        this.mediasList = data.list;

        this.mediasList.map(media => {
          //this.allChx.push(false);
          this.accodionState.push({ state: true });

          media.accodionPannel = true;

          let obj = {};
          media.inventories.map(inventory => {
            inventory.choice = false;
            if (inventory.id) {
              inventory.start_at = campaignInfo.start_at;
              inventory.end_at = campaignInfo.end_at;
              obj.startDate = campaignInfo.start_at;
              obj.endDate = campaignInfo.end_at;
            }
            inventory.dateRange = obj;
          });
          bus.$emit('end:spinner');
        });
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    updateDateRange(i, j, dr, item) {
      item.start_at = item.dateRange.startDate;
      item.end_at = item.dateRange.endDate;
    },

    async saveCampaignInventories() {
      bus.$emit('start:spinner');
      const id = this.$route.params.id;

      let addInventories = [];
      let addInventoriesMap = {};

      this.mediasList.forEach(media => {
        media.inventories.forEach(inventory => {
          let obj = {};
          if (inventory.choice) {
            obj.id = inventory.id;
            obj.start_at = toISOFormattedDate(
              new Date(inventory.dateRange.startDate),
            );
            obj.end_at = toISOFormattedDate(
              new Date(inventory.dateRange.endDate),
            );
            obj.is_valid = 'N';
            addInventories.push(obj);
            addInventoriesMap[inventory.id] = inventory;
          }
        });
      });

      if (!addInventories.length) {
        this.showSystemAlert = true;
        this.logResult = `최소 1개이상의 지면을 선택해야합니다. `;
        bus.$emit('end:spinner');
      } else {
        const addData = { inventories: addInventories };

        try {
          const { data } = await addCampaignInventory(id, addData);
          if (data.result === 'success') {
            this.listCampaignInventories();
            //this.$router.push({ path: `/campaign/${id}/inventories_list` });
            this.$router.go(-1);
          }
          bus.$emit('end:spinner');
        } catch (error) {
          bus.$emit('end:spinner');

          const { data } = error.response;
          if (data.result === 'IsAlreadyReserved') {
            const dataList = data.list;
            console.log('dataList', dataList);
            //const choiceIdList = Object.keys(addInventoriesMap);
            //let resultIdList = [];
            //choiceIdList.forEach(choiceId => {
            //	dataList.forEach(resultId => {
            //		if (choiceId === resultId) {
            //			resultIdList.push(addInventoriesMap[resultId].name);
            //		}
            //	});
            //});
            let resultIdList = dataList.map(item => {
              return item.inventory_name;
            });
            console.log('resultIdList', resultIdList);
            let resultNames = resultIdList.join(', ');
            this.showSystemAlert = true;
            this.logResult = `선택된 지면 [ ${resultNames} ]은 현재 집행중인
					캠페인이 있습니다.`;
          }
          if (data.result === 'OutRange') {
            const dataList = data.data;
            const choiceIdList = Object.keys(addInventoriesMap);
            let resultIdList = [];
            choiceIdList.forEach(choiceId => {
              dataList.forEach(resultId => {
                if (choiceId === resultId) {
                  resultIdList.push(addInventoriesMap[resultId].name);
                }
              });
            });
            let resultNames = resultIdList.join(', ');
            this.showSystemAlert = true;
            this.logResult = `[ ${resultNames} ] 지면의 시작/종료는 캠페인의
시작, 종료일 범위 내에서만 설정 가능합니다.`;
          }
        }
      }
    },
    closePopup() {
      this.showSystemAlert = false;
      this.logResult = '';
    },
    cancel() {
      //const id = this.$route.params.id;
      //this.$router.push({ path: `/campaign/${id}/inventories_list` });
      this.$router.go(-1);
    },
    preview(item) {
      this.showPreview = true;
      this.previewItem = item;
    },
    viewNote(item) {
      this.showNote = true;
      this.previewItem = item;
    },
    viewSchedule(item, mediaId) {
      this.showSchedule = true;
      this.previewItem = item;
      this.mediaId = mediaId;
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.listCampaignInventories();
  },
};
</script>

<style lang="scss" scoped>
.container-box .v-data-table__wrapper {
  overflow-x: initial !important;
  overflow-y: initial !important;
}
.container-box .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>
